/**
 * User: Rob Richard
 * Date: 6/6/14
 * Time: 11:37 AM
 */

'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var Period = module.exports = SoaModel.extend();

var _ = require('underscore');

var unitDisplayVals = {};

_.extend(Period, {
    UNIT_SECOND: 'SECOND',
    UNIT_MINUTE: 'MINUTE',
    UNIT_DAY: 'DAY',
    UNIT_BUSINESS_DAY: 'BUSINESS_DAY',
    UNIT_WEEK: 'WEEK',
    UNIT_MONTH: 'MONTH',
    UNIT_YEAR: 'YEAR',
    unitDisplayVals: unitDisplayVals,
    MONTHS_IN_QUARTER: 3
});

unitDisplayVals[Period.UNIT_SECOND] = {
    one: 'second',
    many: 'seconds'
};
unitDisplayVals[Period.UNIT_MINUTE] = {
    one: 'minute',
    many: 'minutes'
};
unitDisplayVals[Period.UNIT_DAY] = {
    one: 'day',
    many: 'days'
};
unitDisplayVals[Period.UNIT_BUSINESS_DAY] = {
    one: 'business day',
    many: 'business days'
};
unitDisplayVals[Period.UNIT_WEEK] = {
    one: 'week',
    many: 'weeks'
};
unitDisplayVals[Period.UNIT_MONTH] = {
    one: 'month',
    many: 'months'
};
unitDisplayVals[Period.UNIT_YEAR] = {
    one: 'year',
    many: 'years'
};

_.extend(Period.prototype, {
    getInDays: function () {
        // TODO make work with units other than days and weeks
        var days = parseInt(this.get('numberOfUnits'), 10) || 0;
        if (this.get('timeUnit') === Period.UNIT_WEEK) {
            days *= 7;
        }
        return days;
    },
    getDisplayUnit: function () {
        var displayVals = Period.unitDisplayVals[this.get('timeUnit')];
        if (this.get('numberOfUnits') === 1) {
            return displayVals && displayVals.one;
        }

        return displayVals && displayVals.many;
    },
    getDisplayVal: function () {
        var num = this.get('numberOfUnits');
        if (_.isNumber(num)) {
            return this.get('numberOfUnits') + ' ' + this.getDisplayUnit();
        } else {
            return '';
        }
    },
    isQuarter: function () {
        var num = this.get('numberOfUnits');
        return parseInt(num, 10) === Period.MONTHS_IN_QUARTER;
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/Period.js
// module id = 114
// module chunks = 62